<ng-template #prodMap>
  <div class="vote-map">
    <span class="title text-center w-100">{{ selectedVoteCatForMap?.categoryName }} </span>
  </div>
  <div id="map_1"></div>
</ng-template>

<ng-template>
  <div class="bottom-sheet-votes">
    <div class="my-modal__close" (click)="closeModalByRef()">
      <i class="fa-solid fa-times"></i>
      <i class="fa-solid fa-angle-down"></i>
    </div>
    <div class="my-modal__body">
      <div class="title">{{ currentVoteCat?.categoryName }}</div>
      <!-- <div class="address">697-699 North Bridge Rd , 198675</div> -->
      <div class="entries">{{ userCommentsTotal.length }} entries</div>
    </div>

    <div class="comments">
      <div class="comments__graph" [class.d-none]="!compData?.length">
        <canvas id="myChart" #myChart></canvas>
      </div>
      <div *ngIf="!userComments?.length" class="no-comments"><i class="fas fa-heart-broken"></i> No Comments Yet</div>
      <div class="comments__texts">
        <div class="card" *ngFor="let cmt of userComments; index as k" [class]="'color-' + (k % 3)">
          <div class="profile">
            <!-- <img [src]="imgUrl + cmt.characterImageUpload" /> -->
            <span class="text">{{ cmt?.answer }}</span>
          </div>

          <div class="name">
            <span>{{ cmt?.userName }}</span>
            <span> {{ cmt?.createdAt | date: "dd-MM-yyyy" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<div class="votes">
  <div class="container">
    <div class="votes__header">
      <img class="image-left" src="../../../../../../../assets/images/votes-2.png" alt="" />
      <img class="image-right" src="../../../../../../../assets/images/votes-1.png" alt="" />
      <div class="votes__header--title">Voted most popular in {{ subRegionName ? subRegionName : "" }}</div>
      <!-- <div class="votes__header--desc">Hungry yet? These are the top 3 food spots for the 10 dishes Singaporeans can’t get enough of.</div> -->
      <div class="votes__header--tags">
        <!-- <div>Food & Beverage</div>
        <div class="active">Local Delights</div>
        <div>Tuition</div>
        <div>Friends</div>
        <div>Food Beverage</div> -->
        <ng-container *ngFor="let cat of categories">
          <div [class.active]="selectedCategoryId == cat.id" (click)="fetchByCategory(cat)" *ngIf="cat?.hasPoll || anyChildHasPoll(cat)">
            {{ cat.name }}
          </div>
        </ng-container>
      </div>
    </div>
    <div *ngIf="!votes?.length" class="d-flex w-100 justify-content-center align-items-center">
      <span>No Votes In This Category</span>
    </div>
    <app-my-carousel-swiper [config]="carouselOptions" navigationDesign="arrows-right">
      <ng-container *ngFor="let vote of [1]; let i = index">
        <div class="swiper-slide" *ngFor="let voteCat of votes; index as j">
          <div class="votes__card">
            <div class="votes__card--title" (click)="openComments(voteCat)">
              <span class="num">#{{ j + 1 }}</span> <span>{{ voteCat.categoryName }}</span>
              <div class="d-flex" style="gap: 1rem">
                <button class="my-2 t-btn" (click)="$event.stopPropagation(); openPollOn(voteCat)"><i class="fa-solid fa-poll"></i></button>
                <button class="t-btn" (click)="$event.stopPropagation(); openMapOn(prodMap, voteCat)"><i class="fa-solid fa-map"></i></button>
              </div>
            </div>

            <ng-container *ngFor="let prod of voteCat.products; index as i">
              <div class="votes__card--body" *ngIf="i < 5">
                <div>
                  <div class="name">{{ prod?.name }}</div>
                  <div class="bottom">
                    <div class="address">{{ prod?.subRegionName }} {{ prod?.postalCode }}</div>
                  </div>

                  <!-- <a (click)="openVerticallyCentered(content)">View Entries</a> -->
                </div>
                <div class="prod-image" (click)="openProduct(prod)">
                  <!-- <div class="qr-code__by">Enabled by</div> -->
                  <img [src]="imgUrl + prod.indexImage" (click)="showImage(prod.indexImage)" alt="product Image" (error)="onImgError($event)" />

                  <div class="poll-action" *ngIf="user">
                    <label [for]="'yes' + prod.id">Good</label>
                    <input type="checkbox" [id]="'yes' + prod.id" [checked]="prod.haveIVoted" (click)="$event.stopPropagation()" (change)="pollCheck($event, voteCat, prod)" />
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- <button class="t-btn" >See Comments</button> -->
            <!-- <div class="votes__card--body">
              <div>
                <div class="name">Ya Kun Kaya Toast</div>
                <div class="address">18 CHINA STREET FAR EAST SQUARE #01-01 SINGAPORE 049560</div>
                <a>View Entries</a>
              </div>
              <div class="qr-code">
                <div class="qr-code__by">Enabled by</div>
                <img src="../../../../../../../assets/images/votes-qr.jpg" alt="" />
              </div>
            </div>
            <div class="votes__card--body">
              <div>
                <div class="name">928 Yishun Laksa</div>
                <div class="address">928 YISHUN CENTRAL 1 SINGAPORE 760928</div>
                <a>View Entries</a>
              </div>
              <div class="qr-code">
                <div class="qr-code__by">Enabled by</div>
                <img src="../../../../../../../assets/images/votes-qr.jpg" alt="" />
              </div>
            </div> -->
          </div>
        </div>
      </ng-container>
    </app-my-carousel-swiper>
  </div>
</div>

<ng-template #comments let-modal>
  <div class="bottom-sheet-votes p-3">
    <div class="my-modal__close" (click)="closeModalByRef()">
      <i class="fa-solid fa-times"></i>
      <i class="fa-solid fa-angle-down"></i>
    </div>
    <div class="my-modal__body">
      <!-- <div class="title">Singapore Zam Zam Restaurant</div>
    <div class="address">697-699 North Bridge Rd , 198675</div>
    <div class="entries">35 entries</div> -->
      <div class="title">{{ currentVoteCat?.categoryName }}</div>
      <!-- <div class="address">697-699 North Bridge Rd , 198675</div> -->
      <div class="entries">{{ userCommentsTotal.length }} entries</div>

      <div class="votes-popup__graph" [class.d-none]="!compData?.length">
        <canvas id="myChart" #myChart></canvas>
      </div>

      <div class="votes-popup__cards">
        <div class="card" *ngFor="let cmt of userComments; index as k" [class]="'color-' + ((k % 3) + 1)">
          <div class="profile">
            <!-- <img [src]="imgUrl + cmt.characterImageUpload" /> -->
            <span class="text">{{ cmt?.answer }}</span>
          </div>

          <div class="name">
            <span>{{ cmt?.userName }}</span>
            <span> {{ cmt?.createdAt | date: "dd-MM-yyyy" }}</span>
          </div>

          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</ng-template>
